webpackJsonp([84036413560378],{

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.toggleScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _togglePanel = __webpack_require__(415);
	
	var _togglePanel2 = _interopRequireDefault(_togglePanel);
	
	var _toggle = __webpack_require__(908);
	
	var _toggle2 = _interopRequireDefault(_toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.toggleScxml = _toggle2.default;
	
	var XStateToggleExample = function (_React$Component) {
	  _inherits(XStateToggleExample, _React$Component);
	
	  function XStateToggleExample(props) {
	    _classCallCheck(this, XStateToggleExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { log: [] };
	    return _this;
	  }
	
	  XStateToggleExample.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _scxml2.default.documentStringToModel(null, _toggle2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  XStateToggleExample.prototype.customSend = function customSend(event) {
	    if (event.name === 'trace') {
	      this.setState(function (_ref) {
	        var log = _ref.log;
	        return { log: log.concat(event.data).slice(-12) };
	      });
	    } else {
	      this.sc.gen(event);
	    }
	  };
	
	  XStateToggleExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  XStateToggleExample.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '500px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '500px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _toggle2.default,
	            disableAnimation: true,
	            disableZoom: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'xstate-toggle'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '500px', border: '1px solid #eee' } },
	          _react2.default.createElement(_togglePanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this3.send(event);
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return XStateToggleExample;
	}(_react2.default.Component);
	
	exports.default = XStateToggleExample;

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TogglePanel = function TogglePanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      log = _ref.log,
	      onEvent = _ref.onEvent;
	
	  var states = configuration || [];
	  var isActive = states.indexOf('active') > -1;
	  var toggleCount = datamodel && typeof datamodel.toggleCount !== 'undefined' ? datamodel.toggleCount : 0;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { background: isActive ? '#1f7a4d' : '#4c5964', color: '#fff', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'Toggle state'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: '2rem', lineHeight: '2.4rem' } },
	        isActive ? 'active' : 'inactive'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        isActive ? 'The modeled switch is enabled.' : 'The modeled switch is disabled.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { background: '#fff', border: '1px solid #ddd', padding: '0.75rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Toggle count'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        toggleCount
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('TOGGLE');
	          } },
	        'Toggle'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('SET_ACTIVE');
	          } },
	        'Set active'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('SET_INACTIVE');
	          } },
	        'Set inactive'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', style: { marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('RESET');
	          } },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = TogglePanel;
	module.exports = exports['default'];

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"inactive\"\n       name=\"ToggleExample\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"enabled\" expr=\"false\"/>\n    <data id=\"toggleCount\" expr=\"0\"/>\n  </datamodel>\n\n  <state id=\"inactive\">\n    <onentry>\n      <assign location=\"enabled\" expr=\"false\"/>\n      <send event=\"trace\"><content expr=\"'Toggle is inactive.'\"/></send>\n    </onentry>\n    <transition event=\"TOGGLE SET_ACTIVE\" target=\"active\">\n      <assign location=\"toggleCount\" expr=\"toggleCount + 1\"/>\n    </transition>\n  </state>\n\n  <state id=\"active\">\n    <onentry>\n      <assign location=\"enabled\" expr=\"true\"/>\n      <send event=\"trace\"><content expr=\"'Toggle is active.'\"/></send>\n    </onentry>\n    <transition event=\"TOGGLE SET_INACTIVE\" target=\"inactive\">\n      <assign location=\"toggleCount\" expr=\"toggleCount + 1\"/>\n    </transition>\n    <transition event=\"RESET\" target=\"inactive\">\n      <assign location=\"toggleCount\" expr=\"0\"/>\n    </transition>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _xstateToggleExample = __webpack_require__(414);
	
	var _xstateToggleExample2 = _interopRequireDefault(_xstateToggleExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Toggle = function Toggle(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports Stately\'s XState Toggle example into SCXML. It keeps the same small two-state shape while adding explicit set and reset events for the live browser panel.'
	    ),
	    React.createElement(_xstateToggleExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _xstateToggleExample.toggleScxml
	    )
	  );
	};
	
	var WrappedToggle = function WrappedToggle(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Toggle, pathname: location.pathname });
	};
	
	exports.default = WrappedToggle;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-toggle-js-320457d6b3402a7af054.js